import type { BsiIbLastThirtyItem } from '@/lib/banks/bsi/api';
import { getAccountingPrintSettings } from '@/lib/printSettings';

type ExportOpts = {
  items: BsiIbLastThirtyItem[];
  accountNumber: string;
  title?: string;
};

export async function exportBsiTransactionsExcel(opts: ExportOpts): Promise<void> {
  const ExcelJS = (await import('exceljs')).default;
  const wb = new ExcelJS.Workbook();
  wb.creator = 'Darvag Accounting';
  wb.created = new Date();

  const sheetTitle = opts.title || 'سی گردش آخر';
  const ws = wb.addWorksheet(sheetTitle.slice(0, 31), {
    views: [{ rightToLeft: true }],
    properties: { defaultRowHeight: 20 },
  });

  const company = getAccountingPrintSettings().companyName || 'حسابداری';
  ws.mergeCells(1, 1, 1, 10);
  ws.getCell(1, 1).value = `${company} — ${sheetTitle} بانک صادرات`;
  ws.getCell(1, 1).font = { name: 'Tahoma', size: 14, bold: true };
  ws.getCell(2, 1).value = `حساب: ${opts.accountNumber}`;
  ws.getCell(2, 1).font = { name: 'Tahoma', size: 11 };

  const headers = ['#', 'تاریخ', 'زمان', 'شعبه', 'نوع', 'شماره سند', 'شرح', 'واریز', 'برداشت', 'مانده'];
  const headerRow = ws.getRow(4);
  headers.forEach((h, i) => {
    const cell = headerRow.getCell(i + 1);
    cell.value = h;
    cell.font = { name: 'Tahoma', bold: true, color: { argb: 'FFFFFFFF' } };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1565C0' } };
  });

  opts.items.forEach((item, idx) => {
    const row = ws.getRow(5 + idx);
    row.values = [
      item.row,
      item.date,
      item.time,
      item.branch,
      item.type,
      item.doc_no,
      item.description,
      item.credit || null,
      item.debit || null,
      item.balance || null,
    ];
    row.font = { name: 'Tahoma', size: 10 };
    [8, 9, 10].forEach((col) => {
      row.getCell(col).numFmt = '#,##0';
    });
  });

  ws.columns = [
    { width: 6 },
    { width: 12 },
    { width: 10 },
    { width: 10 },
    { width: 12 },
    { width: 14 },
    { width: 36 },
    { width: 14 },
    { width: 14 },
    { width: 16 },
  ];

  const buffer = await wb.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `bsi-${opts.accountNumber || 'account'}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
}

/** @deprecated use exportBsiTransactionsExcel */
export const exportBsiLastThirtyExcel = exportBsiTransactionsExcel;
